var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("tab-layout", {
    attrs: { buttons: _vm.buttons, permissions: _vm.permissions },
    on: {
      openAddress: function($event) {
        return _vm.openAddress(null)
      },
      openAddressMap: _vm.openFullMap
    },
    scopedSlots: _vm._u([
      {
        key: "title",
        fn: function() {
          return [
            _vm._v(
              " " + _vm._s(_vm.$t.__("overview.tabs.TabAddresses.title")) + " "
            )
          ]
        },
        proxy: true
      },
      {
        key: "content",
        fn: function() {
          return [
            _c("preloader", {
              staticClass: "mt-3",
              attrs: { display: _vm.loading }
            }),
            _vm._v(" "),
            !_vm.loading && _vm.addresses.length > 0
              ? _c(
                  "div",
                  { staticClass: "tab-addresses__list-addresses" },
                  [
                    _vm.mainInvoicingAddress
                      ? _c(
                          "div",
                          [
                            _c(
                              "h4",
                              { staticClass: "typographies-heading-h4" },
                              [
                                _vm._v(
                                  "\n                    " +
                                    _vm._s(_vm.titleMainAddress) +
                                    "\n                "
                                )
                              ]
                            ),
                            _vm._v(" "),
                            _c("AddressCard", {
                              attrs: {
                                permissions: _vm.permissions,
                                address: _vm.mainInvoicingAddress,
                                addressUpdating: _vm.addressUpdating,
                                disableSwitches: _vm.addressSelected
                              },
                              on: {
                                onEdit: _vm.openAddress,
                                onDelete: function($event) {
                                  return _vm.deleteAddress(
                                    _vm.mainInvoicingAddress
                                  )
                                },
                                onDeliveryAddressSwitch: function($event) {
                                  return _vm.defineDeliveryAddress(
                                    _vm.mainInvoicingAddress
                                  )
                                },
                                onInvoicingAddressSwitch: function($event) {
                                  return _vm.defineInvoicingAddress(
                                    _vm.mainInvoicingAddress
                                  )
                                }
                              }
                            })
                          ],
                          1
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.mainDeliveryAddress &&
                    _vm.mainDeliveryAddress.id !== _vm.mainInvoicingAddress.id
                      ? _c(
                          "div",
                          [
                            _c(
                              "h4",
                              { staticClass: "typographies-heading-h4" },
                              [
                                _vm._v(
                                  "\n                    " +
                                    _vm._s(
                                      _vm.$t.__(
                                        "overview.tabs.TabAddresses.title_delivery_address"
                                      )
                                    ) +
                                    "\n                "
                                )
                              ]
                            ),
                            _vm._v(" "),
                            _c("AddressCard", {
                              attrs: {
                                permissions: _vm.permissions,
                                address: _vm.mainDeliveryAddress,
                                addressUpdating: _vm.addressUpdating,
                                disableSwitches: _vm.addressSelected
                              },
                              on: {
                                onEdit: _vm.openAddress,
                                onDelete: function($event) {
                                  return _vm.deleteAddress(
                                    _vm.mainDeliveryAddress
                                  )
                                },
                                onDeliveryAddressSwitch: function($event) {
                                  return _vm.defineDeliveryAddress(
                                    _vm.mainDeliveryAddress
                                  )
                                },
                                onInvoicingAddressSwitch: function($event) {
                                  return _vm.defineInvoicingAddress(
                                    _vm.mainDeliveryAddress
                                  )
                                }
                              }
                            })
                          ],
                          1
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.otherAddresses.length > 0
                      ? _c("div", [
                          _c("h4", { staticClass: "typographies-heading-h4" }, [
                            _vm._v(
                              "\n                    " +
                                _vm._s(
                                  _vm.$t.__(
                                    "overview.tabs.TabAddresses.title_other_addresses"
                                  )
                                ) +
                                "\n                "
                            )
                          ]),
                          _vm._v(" "),
                          _c(
                            "div",
                            { staticClass: "address-card-container" },
                            _vm._l(_vm.otherAddresses, function(address) {
                              return _c("AddressCard", {
                                key: address.id,
                                attrs: {
                                  permissions: _vm.permissions,
                                  address: address,
                                  addressUpdating: _vm.addressUpdating,
                                  disableSwitches: _vm.addressSelected
                                },
                                on: {
                                  onEdit: _vm.openAddress,
                                  onDelete: function($event) {
                                    return _vm.deleteAddress(address)
                                  },
                                  onDeliveryAddressSwitch: function($event) {
                                    return _vm.defineDeliveryAddress(address)
                                  },
                                  onInvoicingAddressSwitch: function($event) {
                                    return _vm.defineInvoicingAddress(address)
                                  }
                                }
                              })
                            }),
                            1
                          )
                        ])
                      : _vm._e(),
                    _vm._v(" "),
                    _c("AddressMap", {
                      attrs: {
                        addresses: _vm.addresses,
                        corpAddress: _vm.mainCorpAddress,
                        visible: _vm.fullMapVisible
                      },
                      on: { close: _vm.closeFullMap }
                    })
                  ],
                  1
                )
              : _c("div", [
                  !_vm.loading
                    ? _c("div", { staticClass: "placeholder" }, [
                        _c("p", [
                          _vm._v(_vm._s(_vm.$l10n.__("Aucune adresse définie")))
                        ])
                      ])
                    : _vm._e()
                ]),
            _vm._v(" "),
            _c(
              "CompassDialog",
              {
                attrs: {
                  visible: _vm.showDeleteModal,
                  size: "small",
                  title: _vm.$t.__("common.labels.delete_address_title"),
                  primaryAction: _vm.primaryActionDeleteAddress,
                  closeOnClickOverlay: false,
                  secondaryActions: [
                    {
                      label: _vm.$t.__("common.actions.cancel"),
                      action: function() {
                        return (_vm.showDeleteModal = false)
                      }
                    }
                  ]
                },
                on: {
                  "update:visible": function($event) {
                    _vm.showDeleteModal = $event
                  },
                  closed: function($event) {
                    _vm.showDeleteModal = false
                  }
                }
              },
              [
                _c(
                  "span",
                  { staticClass: "typographies-paragraph-medium-regular" },
                  [
                    _vm._v(
                      "\n                " +
                        _vm._s(
                          _vm.$t.__("common.labels.delete_address_description")
                        ) +
                        "\n            "
                    )
                  ]
                )
              ]
            )
          ]
        },
        proxy: true
      }
    ])
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }